/*
 * ⋯ 버튼 아래에 fixed 로 띄우는 메뉴가 좁은 화면에서 오른쪽 밖으로 나가지 않게 한다.
 * @param {number} preferredLeft 원래 두려던 left
 * @param {number} width 메뉴 너비(px)
 */
export const clampPopoverLeft = (preferredLeft, width, margin = 8) =>
  Math.max(margin, Math.min(preferredLeft, window.innerWidth - width - margin));
